import { useEffect } from 'react';
import { onOtherDatePopover } from '../../../../../ui/DateTimePopover/popoverBus';

/**
 * Outside click, Escape, and another date popover close this reminder picker.
 * Deps match the previous effect: rebind when it opens, not on every render.
 */
export function useRemindMeDismiss({
  pickerOpen,
  popoverId,
  closePicker,
  triggerRef,
  pickerRef,
}) {
  useEffect(() => {
    if (!pickerOpen) return undefined;
    const onDoc = (e) => {
      if (triggerRef.current?.contains(e.target)) return;
      if (pickerRef.current?.contains(e.target)) return;
      closePicker();
    };
    const onKey = (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      closePicker();
    };
    document.addEventListener('mousedown', onDoc, true);
    document.addEventListener('keydown', onKey, true);
    return () => {
      document.removeEventListener('mousedown', onDoc, true);
      document.removeEventListener('keydown', onKey, true);
    };
    // closePicker is the session reset from the open render; setters are stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickerOpen]);

  useEffect(() => {
    if (!pickerOpen) return undefined;
    return onOtherDatePopover(popoverId, closePicker);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickerOpen, popoverId]);
}
